import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { UnstyledButton } from '@b-stock/fe-core/bstock-next/components'
import { designColors } from '@b-stock/fe-core/theme'

const ClickTarget = styled(UnstyledButton)`
  font-size: 1rem;

  // Only pad left because the icon's bounding box is already taller than the
  // icon would visually suggest, and we need to keep the icon right aligned.
  padding-left: 0.75rem;

  color: ${designColors.neutral.darkGray};
`

const ArrowToggleButton = ({
  className,
  expandedState,
  toggleExpandedState,
}: {
  className?: string
  expandedState: boolean
  toggleExpandedState: () => void
}) => {
  return (
    <ClickTarget
      type="button"
      data-testid="toggle-button"
      onClick={toggleExpandedState}
      className={className}
    >
      <FontAwesomeIcon icon={expandedState ? faAngleUp : faAngleDown} />
    </ClickTarget>
  )
}

export default ArrowToggleButton
